import { Checkbox, ListItemText } from "@mui/material";
import React from "react";
import { Task } from "../Utils/Types/Task";

const ReadonlyTaskCheckBox = (props: {
  task: Task;
  showCheckboxes: boolean;
}) => {
  return (
    <ListItemText>
      {props.showCheckboxes &&
        (props.task.status === "Completed" ? (
          <Checkbox disabled defaultChecked />
        ) : (
          <Checkbox disabled />
        ))}
      {props.task.title}
    </ListItemText>
  );
};

export default ReadonlyTaskCheckBox;
